<template>
    <section class="flex h-[90vh] flex-col">
        <header class="modal-card-head is-radiusless">
            <p class="modal-card-title">Sign Document</p>
        </header>

        <section class="modal-card-body !p-0">
            <DocusealForm class="h-full w-full" :src="src" :email="email" :with-decline="true" @complete="handleComplete" @decline="handleDecline" />
        </section>

        <footer class="modal-card-foot">
            <div class="flex w-full justify-end">
                <NButton size="small" @click="handleClose"> Close </NButton>
            </div>
        </footer>
    </section>
</template>

<script setup lang="ts">
import { DocusealForm } from '@docuseal/vue';
import { NButton } from 'naive-ui';

interface Props {
    src: string;
    email: string;
}

interface Emits {
    (e: 'complete'): void;
    (e: 'decline'): void;
    (e: 'close'): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const handleComplete = () => {
    emit('complete');
};

const handleDecline = () => {
    emit('decline');
};

const handleClose = () => {
    emit('close');
};
</script>
